module.exports = __webpack_public_path__ + "static/EufoniApp-f2c9ca7f4f8267f0703d0f26bbaf5f58.png";